<template>
  <div class="wrap">
    <nav-bar v-if="$route.name!='Login'" :route-name="routeName" />
    <app-main />
    <footerMenu v-if="footerMenuShow"/>
  </div>
</template>

<script>
import WOW from 'wowjs'
import appMain from './components/appMain'
import footerMenu from './components/footerMenu'
export default {
  name: 'layout',
  components: {
    appMain,
    footerMenu
  },
  data () {
    return {
      routeName: '',
      footerMenuShow: true
    }
  },
  mounted () {
    if (window.screen.width < 768 && this.$route.name == 'Freevideo') {
      this.footerMenuShow = false
    } else {
      this.footerMenuShow = true
    }

    if (this.$route.path == '/home') {
      this.routeName = 'Home'
    }

    if (!(/msie [6|7|8|9]/i.test(navigator.userAgent)) && window.screen.width > 768) {
      new WOW.WOW().init()
    };
  },
  beforeRouteUpdate (to, from, next) {
    if (window.screen.width < 768 && to.name == 'Freevideo') {
      this.footerMenuShow = false
    } else {
      this.footerMenuShow = true
    }
    this.routeName = to.name
    next()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/layout/index.vue